const autoDebitInitialState = {
  adCustomerComingFromSSOjourney: false,
  errorContent: {},
  adShowWelcomeScreen: true,
  adShowBankDetailsScreen: false,
  adShowSorryForTroubleScreen: true,
  isEligibleForEmandateCancellation: false,
  ackScreen: {
    statusCode: 10,
    statusMsg: '',
    statusDes: '',
    bgImg: '_',
    primaryCTA: 'Okay, got it',
    secondaryCTA: '',
    fiboLottieJSON: '',
  },
  getNachStatusAPICall: {
    response: {},
    isLoading: false,
    isError: false,
    isSuccess: false,
  },
  globalOverlayLoader: false,
  showRightSidebar: false,
  uploadNACHFormBtnClicked: false,
  currentScreen: 'AD_NO_SCREEN_TO_SHOW',
  previousScreen: 'AD_NO_SCREEN_TO_SHOW',
  nachMethodButtonSelected: '',
  skipAdOnlineThreeChoicesScreen: false,
};

export default autoDebitInitialState;
